
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 25 26","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.41 12.507L12.993 2.09a.694.694 0 00-.979 0L1.598 12.507a.695.695 0 00.979.98L12.5 3.561l9.924 9.931a.695.695 0 00.98-.98l.006-.006z","fill":"#80A0AF"}}),_c('path',{attrs:{"d":"M19.445 22.722h-3.473v-6.944H9.029v6.944H5.556V13l-1.389 1.389v8.333a1.389 1.389 0 001.389 1.39h4.861v-6.945h4.167v6.944h4.86a1.389 1.389 0 001.39-1.389v-8.5l-1.39-1.389v9.89z","fill":"#80A0AF"}})])
          )
        }
      }
    